module.exports = __webpack_public_path__ + "static/img/policy_on.e20f0db9.svg";